import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-lost",
  "use": "icon-status-lost-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-status-lost\"><path d=\"M7.027.027c-3.89 0-7 3.11-7 7s3.11 7 7 7 7-3.11 7-7-3.11-7-7-7m0 1c3.361 0 6 2.64 6 6 0 3.361-2.639 6-6 6-3.36 0-6-2.639-6-6 0-3.36 2.64-6 6-6\" /><path d=\"M3.297 6.323h7.379V7.8h-7.38Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol